export const getMenuOpen = ({ nav }) => nav.menuOpen;
